import { getError, getErrorEmail } from './errorsHandling'
import i18n from '~/i18n'

export const savedDefault = {
  color: 'primary',
  text: i18n.t('FormView.saved'),
}

export const copiedDefault = {
  color: 'primary',
  text: i18n.t('FormView.copied'),
}

export function errorDefault(error: unknown) {
  return {
    color: 'error',
    text: getError(error),
  }
}

export function errorEmail(error: unknown) {
  return {
    color: 'error',
    text: getErrorEmail(error),
  }
}
